import { Space } from "antd";
import React, { useEffect, useState } from "react";

import iconFacility from "../../assets/images/home/rent/icon_home_blue.png";
import iconDuration from "../../assets/images/home/rent/icon_clock_blue.png";
import iconOption from "../../assets/images/home/rent/icon_check_blue.png";
import RentPlaceMap from "../../component/rent/RentPlaceMap";

import * as TypeDTO from "../../commons/typeDTO";

function TravelSpotCard({ place, isHome }: { place: TypeDTO.RentTravelSpotDto; isHome?: boolean }) {
    const [modifiedSpot, setmodifiedSpot] = useState<TypeDTO.RentPlaceDto>();

    useEffect(() => {
        let modifiedSpotsItem: TypeDTO.RentPlaceDto | null = null;
        modifiedSpotsItem = {
            rentRegionId: place.travelSpotId,
            rentRegionDescription: place.travelSpotName,
            latitude: place.latitude,
            longitude: place.longitude,
            address: place.travelSpotAddress,
            marker: place.travelSpotMarkers?.map((markerArray: any) => ({
                facilityType: markerArray.facilityType,
                facilityLatitude: markerArray.latitude,
                facilityLongitude: markerArray.longitude
            })) || [],
            region: place.region?.map((regionArray: any) => ({
                lat: regionArray.lat,
                lng: regionArray.lng
            })) || [],
        };
        setmodifiedSpot(modifiedSpotsItem);
    }, [place]);

    return (
        <div className="media-card" style={{ padding: isHome ? 16 : 12 }}>
            {modifiedSpot && <RentPlaceMap isGuide={true} place={modifiedSpot} />}
            <h6 className="mt-2">
                <a className="text-dark">{place?.travelSpotName}</a>
            </h6>
            <Space direction="vertical" size={2}>
                {place?.surroundingFacility && (
                    <Space size={8} align="baseline">
                        <img width={14} src={iconFacility} />
                        <p className="news-text">{place.surroundingFacility} 보유</p>
                    </Space>
                )}
                {place?.requiredTime && (
                    <Space size={8} align="baseline">
                        <img width={14} src={iconDuration} />
                        <p className="news-text">{place.requiredTime}</p>
                    </Space>
                )}
                {place?.memo && (
                    <Space size={8} align="baseline">
                        <img width={14} src={iconOption} />
                        <p className="news-text">{place.memo}</p>
                    </Space>
                )}
                {place?.caution && <p className="news-text text-note">※{place.caution}</p>}
            </Space>
        </div>
    );
}

export default TravelSpotCard;
